import React, {forwardRef, Fragment, useImperativeHandle, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogTitle, Grid, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {Delete} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import DepartmentService from "@/services/hr/DepartmentService";
import {useSnackbar} from "notistack";
import {CancelButton, SavingButton} from "@/components/data-grid/CustomButton";
import SnackbarUtil from "@/utils/SnackbarUtil";
import GenericService from "@/services/GenericService";
import {ATTEndpoints} from "@/services/att/endpoints";
import ActionButton from "@/components/actions/ActionButton";
import ScheduleService from "@/services/att/services/ScheduleService";

const dialogStyle = {
  '& .MuiPaper-root': {width: '400px', top: '1vh', overflowX: "hidden"},
  '.MuiDialog-paper': {maxWidth: '100vw'},
  overflowX: "hidden",
};

export function DeleteAction({setInfo}: any) {
  const {t} = useTranslation()

  return (
    <Tooltip title={t("common.Delete Schedule?")}>
      <div>
        <ActionButton
          title={t("common.delete")}
          icon='icon-ic_delete'
          handleClick={() => {
            // setInfo(true)
          }}
        > </ActionButton>
      </div>
    </Tooltip>
  )
}

const ScheduleDelete = (props: any, ref: any) => {
  const [info, setInfo] = useState<boolean>(false)
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const [scheduleIds, setScheduleIds] = useState<any>([])
  const [visible, setVisible] = React.useState(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  useImperativeHandle(ref, () => ({
    showDelete: async (id: string) => {
      setScheduleIds(id)
      setInfo(false)
    }
  }));
  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (scheduleIds.length == 0) {
          SnackbarUtil.error(t("att.schedule.Select person first"),
            {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
          return;
        }
        setVisible(open);
        setInfo(true);
      };
  const onSubmit = async (event: any) => {
    try {
      setLoading(true)
      // 执行批量删除操作
      await ScheduleService.bulkDelete(scheduleIds);

      // 删除成功，显示提示
      enqueueSnackbar(t("common.success"), {
        variant: "success",
        anchorOrigin: {vertical: "top", horizontal: "center"}
      });

      // 直接刷新表格，不需要延迟
      if (props.reloadTable) {
        props.reloadTable();
      }
    } catch (e) {
      console.log("error===", e)
    } finally {
      setInfo(false)
      setLoading(false)
    }
  };

  return (
    <Fragment>
      <Grid item={true} onClick={toggleDrawer(true)}>
        <DeleteAction setInfo={setInfo}/>
      </Grid>
      <Dialog
        open={info}
        // onClose={()=>setInfo(false)}
        sx={dialogStyle}
      >
        <DialogTitle style={{marginBottom: "-25px"}}>
          {t("common.Delete Schedule?")}
          <IconButton
            aria-label="close"
            onClick={() => setInfo(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <Typography sx={{p: 3}}>
          {t('common.Are you sure to delete these schedules?')}
        </Typography>
        <Grid style={{marginLeft: "20px", marginRight: "20px", marginBottom: "20px"}}>
          <Stack spacing={3} direction={"row"} justifyContent="flex-end">
            <CancelButton onClick={() => {
              setInfo(false)
            }}/>
            <SavingButton onClick={onSubmit} loading={isLoading} children={t('common.confirm')}/>
          </Stack>
        </Grid>
      </Dialog>
    </Fragment>
  )
}

export default forwardRef(ScheduleDelete);
